import { Injectable } from '@angular/core';
import { DataService } from '../../architecture/data.service';
import { Result } from '../../architecture/envelopes';
import { Dealer } from '../../models/dealer.model';

@Injectable({ providedIn: 'root' })
export class DealerService {
    constructor(private dataService: DataService) {}

    public get() {
        return this.dataService.get<Result<Dealer[]>>('dealer');
    }

    public getByCurrentUser() {
        return this.dataService.get<Result<Dealer[]>>('dealer/currentUser');
    }
}
